import React from "react";
import { useDispatch } from "react-redux";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik } from "formik";
import * as yup from "yup";
import * as InterconexonActions from "app/@Base/store/actions";

import "react-datepicker/dist/react-datepicker.css";

registerLocale("es", es);

const MAX_BIRTHDAY = new Date();
MAX_BIRTHDAY.setFullYear(MAX_BIRTHDAY.getFullYear() - 18);

const schema = yup.object().shape({
  id: yup
    .number()
    .required("Requerido")
    .test(
      "len",
      "Solo se permiten entre 9 y 15 caracteres",
      (val) =>
        val > 0 && val.toString().length >= 9 && val.toString().length <= 15
    )
    .typeError("Solo permite números [0-9]"),
  birthday: yup
    .date()
    .max(MAX_BIRTHDAY, "Debe ser mayor de 18 años")
    .required("Requerido")
    .typeError("Dato requerido"),
});

var inputTypeNumbers = document.querySelectorAll("input[type=number]");
for (var a = 0; a < inputTypeNumbers.length; a++) {
  inputTypeNumbers[a].onwheel = function (event) {
    event.target.blur();
  };
}

const ValidarDelegado = ({ ...props }) => {
  const dispatch = useDispatch();

  const handleOnSubmit = (values, action) => {
    let newDate = new Date(values.birthday);
    newDate.setUTCHours(0, 0, 0, 0);
    dispatch(
      InterconexonActions.postDelegado({
        FechaNacimiento: newDate.toISOString(),
        Identificacion: values.id + "",
      })
    );
    action.setFieldTouched("birthday", true);
    action.setSubmitting(false);
  };

  return (
    <div className="card-validar-delegado">
      <h1 className="delegado-title">Delegados</h1>
      <Formik
        initialValues={{ id: "", birthday: "" }}
        validationSchema={schema}
        onSubmit={handleOnSubmit}
      >
        {({
          values,
          dirty,
          errors,
          touched,
          setFieldValue,
          handleChange,
          handleSubmit,
          isSubmitting,
          submitCount,
        }) => (
          <form className="validar-form" onSubmit={handleSubmit}>
            {dirty && errors && submitCount > 0 && (
              <div className="alert alert-danger fade show" role="alert">
                <strong>Datos Incorrectos.</strong>
                <br />
                Por favor validar que los datos ingresados son los correctos.
              </div>
            )}
            <div className="form-group-delegate">
              <label className="form-label" htmlFor="id">
                Cédula
              </label>
              <input
                id="id"
                name="id"
                type="number"
                className={errors.id && touched.id && "is-invalid"}
                placeholder="Sin espacio ni guiones"
                value={values.id}
                onChange={handleChange}
                onBlur={() => {}}
              />
              {errors.id && touched.id && (
                <div className="invalid-feedback d-block justify-content-end">
                  {errors.id}
                </div>
              )}
            </div>
            <div className="form-group-delegate">
              <label className="form-label" htmlFor="birthday">
                Fecha de Nacimiento
              </label>
              <DatePicker
                id="birthday"
                name="birthday"
                className={errors.birthday && touched.birthday && "is-invalid"}
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                locale="es"
                selected={values.birthday}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                maxDate={MAX_BIRTHDAY}
                value={values.birthday}
                onChange={(e) => setFieldValue("birthday", e, true)}
                withPortal
              />
              {errors.birthday && touched.birthday && (
                <div className="invalid-feedback d-block justify-content-end">
                  {errors.birthday}
                </div>
              )}
            </div>
            <div className="w-100">
              <button
                className="form-btn"
                type="submit"
                id="ValidateButton"
                disabled={!dirty || isSubmitting}
              >
                Ingresar
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default ValidarDelegado;
